import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg27 from "../../../assets/svg/svg27.svg";
import img20 from "../../../assets/img/image20.png";
import InsideHeader from "../../../components/InsideHeader";
import { fetchShiftRequest } from "../../../features/dropdown/dropdownSlice";
import { dateForHumans } from "../../../utils";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import ConfirmSubmitModal from "../../../components/ConfirmSubmitModal";

export default function ShiftRequestTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { shiftReq, loading, shiftReqCount } = useSelector(
    (state) => state.dropdown
  );
  const {saving} =  useSelector((state)=>state.save)

  const [searchText, setSearchText] = useState("");

  const filterDataList = searchText
    ? shiftReq?.filter(
        (item) =>
          item?.shrNewShift?.toLowerCase().includes(searchText.toLowerCase()) ||
          item?.shrOldShift?.toLowerCase().includes(searchText.toLowerCase())  
      )
    : shiftReq;

  const [prodd, setProdd] = useState("");
  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const handleConfirmation = async (item) => { 
    await setIsModalOpenSubmit(true);
  };

  const handleApprove = async () => {
    const res = await dispatch(
      save({
        url: `shift/postShiftRequest.action?shrId=${prodd?.shrId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchShiftRequestData();
      await setIsModalOpenSubmit(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleConfirmation}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Approve
        </Link>
      ),
    },
  ]
  const columns = [
    {
      title: "No.",
      dataIndex: "shrNo",
      sorter: (a, b) => a.shrNo - b.shrNo,
    },
    {
      title: "Employee Name",
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.localeCompare(b.fullName),
    },
    {
      title: "Employee No.",
      dataIndex: "pfno",
      sorter: (a, b) => a.pfno - b.pfno,
    }, 
    {
      title: "New Shift Name",
      dataIndex: "shrNewShift",
      sorter: (a, b) => a.shrNewShift.localeCompare(b.shrNewShift),
    },
    {
      title: "Old Shift Name",
      dataIndex: "shrOldShift",
      sorter: (a, b) => a.shrOldShift.localeCompare(b.shrOldShift),
    }, 
    {
      title: "Comments",
      dataIndex: "shrComments",
      sorter: (a, b) => a.shrComments.localeCompare(b.shrComments),
    },  
    {
      title: "Last Modified Date",
      dataIndex: "lastModifiedDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.lastModifiedDate - b.lastModifiedDate,
    },
    {
      title: "Status",
      dataIndex: "shrStatus",
      render: (item) => {
        const colors = { 
          COMPLETED: "#2DD683", 
          OPEN: "#FFAB00",
          REJECTED:'#9D1500'
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },
  
    {
      title: "Actions",
      render: (item) => ( 
         <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </> 
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchShiftRequestData(page, size) {
    dispatch(
      fetchShiftRequest({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchShiftRequestData();
  }, []);

 
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Shift Request Approval Information"
        subtitle="Approve shift requests within your institution"
        back={false}
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Shift Request Approval Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by name or keyword"
                className="text-[16px] font-[400] flex-row-reverse search-input"
                prefix={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2508 3.75C7.50609 3.75 4.47041 6.93997 4.47041 10.875C4.47041 14.81 7.50609 18 11.2508 18C14.9955 18 18.0312 14.81 18.0312 10.875C18.0312 6.93997 14.9955 3.75 11.2508 3.75ZM3.04297 10.875C3.04297 6.11154 6.71773 2.25 11.2508 2.25C15.7838 2.25 19.4586 6.11154 19.4586 10.875C19.4586 15.6385 15.7838 19.5 11.2508 19.5C6.71773 19.5 3.04297 15.6385 3.04297 10.875Z"
                      fill="#333333"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.045 15.913C16.3237 15.6201 16.7756 15.6201 17.0543 15.913L21.3902 20.4693C21.6689 20.7622 21.6689 21.237 21.3902 21.5299C21.1115 21.8228 20.6596 21.8228 20.3809 21.5299L16.045 16.9737C15.7663 16.6808 15.7663 16.2059 16.045 15.913Z"
                      fill="#333333"
                    />
                  </svg>
                }
              />
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.shrId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: shiftReqCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchShiftRequestData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handleApprove}
        loading={saving}
        content={`Are you sure you want to approve request for ${prodd?.fullName}?`} 
      />
    </div>
  );
}
